import { FC, ReactNode, useCallback } from "react";
import { useApiClient } from "@hostingbv/lib/src/api";
import { config } from "../config";
import { RealtimeDeploymentProvider } from "./deployments/RealtimeDeployments";

export const RealtimeDeploymentProviderPartnerAdapter: FC<{ children: ReactNode }> = ({ children }) => {
  const { partnerClient } = useApiClient(config)
  const resolveDeployments = useCallback(async () => {
    const response = await partnerClient.getDeployments()
    return response.success ? response.data : [];
  }, [partnerClient])
  return <RealtimeDeploymentProvider resolveDeployments={resolveDeployments}>
    {children}
  </RealtimeDeploymentProvider>
}
